import { useEffect, useState } from "react";
import { api, errMsg } from "@/lib/api";
import { Loader2 } from "lucide-react";

const DOW = ["lun", "mar", "mer", "gio", "ven", "sab", "dom"];
const ymd = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
const jsToIt = (d) => (d.getDay() + 6) % 7;

export const SlotPicker = ({ url, info, value, onChange }) => {
  const days = [];
  for (let i = 0; i <= Math.min(info.max_days, 21); i++) {
    const d = new Date();
    d.setDate(d.getDate() + i);
    if (info.days.includes(jsToIt(d))) days.push(d);
  }
  const [date, setDate] = useState(days[0] ? ymd(days[0]) : "");
  const [slots, setSlots] = useState([]);
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState("");

  useEffect(() => {
    if (!date) return;
    setLoading(true);
    setErr("");
    api.get(url, { params: { date } })
      .then((r) => setSlots(r.data.slots))
      .catch((e) => setErr(errMsg(e)))
      .finally(() => setLoading(false));
  }, [url, date]);

  return (
    <div className="space-y-5" data-testid="slot-picker-wrap">
      <div className="flex gap-2 overflow-x-auto pb-2 -mx-1 px-1">
        {days.map((d) => {
          const k = ymd(d);
          const active = k === date;
          return (
            <button key={k} data-testid={`day-${k}`} onClick={() => { setDate(k); onChange(null); }}
              className={`shrink-0 w-16 rounded-xl border py-2.5 text-center transition-colors ${active ? "bg-[#0F172A] border-[#0F172A] text-white" : "bg-white border-slate-200 hover:border-sky-400"}`}>
              <span className="block text-[11px] uppercase tracking-wider opacity-70">{DOW[jsToIt(d)]}</span>
              <span className="block text-lg font-display font-bold">{d.getDate()}</span>
              <span className="block text-[11px] opacity-70">{d.toLocaleDateString("it-IT", { month: "short" })}</span>
            </button>
          );
        })}
      </div>
      {loading ? (
        <div className="py-8 grid place-items-center text-slate-400"><Loader2 className="h-5 w-5 animate-spin" /></div>
      ) : err ? (
        <p className="text-sm text-rose-600">{err}</p>
      ) : slots.length === 0 ? (
        <p data-testid="no-slots" className="text-sm text-slate-500 py-6 text-center">Nessun orario libero in questo giorno. Prova un altro giorno.</p>
      ) : (
        <div className="grid grid-cols-3 sm:grid-cols-4 gap-2">
          {slots.map((s) => (
            <button key={s} data-testid={`slot-${new Date(s).toLocaleTimeString("it-IT", { hour: "2-digit", minute: "2-digit" }).replace(":", "")}`} onClick={() => onChange(s)}
              className={`rounded-lg border py-2.5 text-sm font-mono font-medium transition-colors ${value === s ? "bg-sky-600 border-sky-600 text-white" : "bg-white border-slate-200 hover:border-sky-500 hover:text-sky-700"}`}>
              {new Date(s).toLocaleTimeString("it-IT", { hour: "2-digit", minute: "2-digit" })}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};
